"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/technical-documentation/technical-documentation/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePattern = exports.metaSchemaRef = void 0;

var codegen_1 = require("ajv/dist/compile/codegen");

var META_SCHEMA_ID = "http://json-schema.org/schema";

function metaSchemaRef() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      defaultMeta = _ref.defaultMeta;

  return defaultMeta === false ? {} : {
    $ref: defaultMeta || META_SCHEMA_ID
  };
}

exports.metaSchemaRef = metaSchemaRef;

function usePattern(_ref2, pattern) {
  var gen = _ref2.gen,
      opts = _ref2.it.opts;
  var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : opts.unicodeRegExp ? "u" : "";
  var rx = new RegExp(pattern, flags);
  return gen.scopeValue("pattern", {
    key: rx.toString(),
    ref: rx,
    code: (0, codegen_1._)(_templateObject || (_templateObject = _taggedTemplateLiteral(["new RegExp(", ", ", ")"])), pattern, flags)
  });
}

exports.usePattern = usePattern;